// Action Types
export const MINUTES_ACTION_TYPES = {
  // Fetch minutes by business
  FETCH_MINUTES_REQUEST: "minutes/FETCH_MINUTES_REQUEST",
  FETCH_MINUTES_SUCCESS: "minutes/FETCH_MINUTES_SUCCESS",
  FETCH_MINUTES_FAILURE: "minutes/FETCH_MINUTES_FAILURE",

  // Fetch minute by id
  FETCH_MINUTE_REQUEST: "minutes/FETCH_MINUTE_REQUEST",
  FETCH_MINUTE_SUCCESS: "minutes/FETCH_MINUTE_SUCCESS",
  FETCH_MINUTE_FAILURE: "minutes/FETCH_MINUTE_FAILURE",

  // Create minute
  CREATE_MINUTE_REQUEST: "minutes/CREATE_MINUTE_REQUEST",
  CREATE_MINUTE_SUCCESS: "minutes/CREATE_MINUTE_SUCCESS",
  CREATE_MINUTE_FAILURE: "minutes/CREATE_MINUTE_FAILURE",

  // Update minute
  UPDATE_MINUTE_REQUEST: "minutes/UPDATE_MINUTE_REQUEST",
  UPDATE_MINUTE_SUCCESS: "minutes/UPDATE_MINUTE_SUCCESS",
  UPDATE_MINUTE_FAILURE: "minutes/UPDATE_MINUTE_FAILURE",

  // Delete minute
  DELETE_MINUTE_REQUEST: "minutes/DELETE_MINUTE_REQUEST",
  DELETE_MINUTE_SUCCESS: "minutes/DELETE_MINUTE_SUCCESS",
  DELETE_MINUTE_FAILURE: "minutes/DELETE_MINUTE_FAILURE",

  // UI Actions
  SET_SELECTED_MINUTE: "minutes/SET_SELECTED_MINUTE",
  CLEAR_SELECTED_MINUTE: "minutes/CLEAR_SELECTED_MINUTE",
  SET_FILTER: "minutes/SET_FILTER",
  CLEAR_ERROR: "minutes/CLEAR_ERROR",
};
